import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface AdditionalOrderInfoState {
    additionalOrderEmail?: string
}

const initialCustomDataState: AdditionalOrderInfoState = {additionalOrderEmail: "" };

const AdditionalOrderInfoReducer = createTypedReducerWithImmer(initialCustomDataState, {
    "Custom/AdditionalOrderInfo/SetAdditionalOrderInfo": (draft: Draft<AdditionalOrderInfoState>, 
        action: { additionalOrderEmail: string},
        ) => {
        draft.additionalOrderEmail = action.additionalOrderEmail
    },
    "Custom/AdditionalOrderInfo/ClearAdditionalOrderInfo": draft => {
        draft.additionalOrderEmail = "";
    },
});

export default (reducers as any).additionalOrderInfoState = AdditionalOrderInfoReducer;

export type CustomAdditionalOrderInfoState = {
    additionalOrderInfoState: AdditionalOrderInfoState;
} & ApplicationState;

type Reducers = {
    AdditionalOrderInfoReducer: typeof AdditionalOrderInfoReducer;
};

export type AdditionalOrderInfoActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
